import { useEffect, useState } from "react";

/** Acompanha uma media query (ex.: tela larga) e re-renderiza quando muda. */
export function useMidia(consulta: string): boolean {
  const [casa, setCasa] = useState(
    () => typeof window !== "undefined" && window.matchMedia(consulta).matches,
  );
  useEffect(() => {
    const m = window.matchMedia(consulta);
    const mudar = () => setCasa(m.matches);
    mudar();
    m.addEventListener("change", mudar);
    return () => m.removeEventListener("change", mudar);
  }, [consulta]);
  return casa;
}
